const PersonStart = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      style={{ width: "var(--width-48)", height: "var(--height-48)" }}
      viewBox="0 0 48 48"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M29 10.9999C29 7.13397 25.8659 4 22 4L21.6159 4.01031C17.9285 4.20972 14.9999 7.26288 14.9999 10.9999C14.9999 14.866 18.134 18 22 18L22.3841 17.9896C26.0714 17.7903 29 14.7371 29 10.9999ZM23.9999 34C23.9999 36.1857 24.5843 38.235 25.6053 40H8V32.8C8 26.9844 12.4689 22.2424 18.0672 22.009L18.4999 22H25.4999C27.3219 22 29.0354 22.4773 30.5289 23.3169C26.6524 25.3062 23.9999 29.3433 23.9999 34ZM30.1221 42.0902L35.9999 38.5L41.8778 42.0902L40.2797 35.3905L45.5105 30.9098L38.645 30.3594L35.9999 24L33.3549 30.3594L26.4894 30.9098L31.7202 35.3905L30.1221 42.0902Z"
        fill="white"
      />
    </svg>
  );
};

export default PersonStart;
